"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _content = require("../content");
var _envConstants = require("../env-constants");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CustomTrustPilot = /*#__PURE__*/function (_React$Component) {
  function CustomTrustPilot() {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomTrustPilot);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CustomTrustPilot, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      trustPilotData: [],
      isLoading: true
    });
    (0, _defineProperty2["default"])(_this, "setTrustPilotData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _content.getTrustPilot)().then(function (data) {
              return data && _this.setState({
                trustPilotData: data,
                isLoading: false
              });
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return _this;
  }
  (0, _inherits2["default"])(CustomTrustPilot, _React$Component);
  return (0, _createClass2["default"])(CustomTrustPilot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setTrustPilotData();
    }
  }, {
    key: "render",
    value: function render() {
      var numberOfReviews = this.state.trustPilotData.numberOfReviews;
      if (!this.state.isLoading) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "tal"
        }, /*#__PURE__*/_react["default"].createElement("h3", null, "Excellent", /*#__PURE__*/_react["default"].createElement("img", {
          alt: "star",
          style: {
            width: 20,
            marginLeft: 10
          },
          src: "https://assets.theyachtweek.com/wp-content/uploads/2019/01/Screen-Shot-2019-01-28-at-04.43.43.png"
        }), /*#__PURE__*/_react["default"].createElement("img", {
          alt: "star",
          style: {
            width: 20,
            marginLeft: 2
          },
          src: "https://assets.theyachtweek.com/wp-content/uploads/2019/01/Screen-Shot-2019-01-28-at-04.43.43.png"
        }), /*#__PURE__*/_react["default"].createElement("img", {
          alt: "star",
          style: {
            width: 20,
            marginLeft: 2
          },
          src: "https://assets.theyachtweek.com/wp-content/uploads/2019/01/Screen-Shot-2019-01-28-at-04.43.43.png"
        }), /*#__PURE__*/_react["default"].createElement("img", {
          alt: "star",
          style: {
            width: 20,
            marginLeft: 2
          },
          src: "https://assets.theyachtweek.com/wp-content/uploads/2019/01/Screen-Shot-2019-01-28-at-04.43.43.png"
        }), /*#__PURE__*/_react["default"].createElement("img", {
          alt: "star",
          style: {
            width: 20,
            marginLeft: 2
          },
          src: "https://assets.theyachtweek.com/wp-content/uploads/2019/01/Screen-Shot-2019-01-28-at-04.43.43.png"
        })), /*#__PURE__*/_react["default"].createElement("p", null, "See all ", /*#__PURE__*/_react["default"].createElement("strong", null, numberOfReviews.total), " reviews on", /*#__PURE__*/_react["default"].createElement("a", {
          target: "_blank",
          href: "https://www.trustpilot.com/review/".concat(_envConstants.ENV.PROD_ROOT_DOMAIN),
          style: {
            margin: '0px 0px 0px 5px'
          }
        }, /*#__PURE__*/_react["default"].createElement("img", {
          alt: "Trust Pilot",
          style: {
            maxWidth: 90,
            position: 'relative',
            top: -4
          },
          src: "https://assets.theyachtweek.com/wp-content/uploads/2019/01/Screen-Shot-2019-01-28-at-05.22.50.png"
        })), ' '));
      }
      return null;
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = CustomTrustPilot;